import React from 'react'
import { Nav } from '../components/Nav.js'
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContextComponent';
import { useContext } from 'react';

const SignOut = () => {
  const { isLoggedIn, setIsLoggedIn, user, setUser} = useContext(AuthContext)
  // const navigate = useNavigate()
   localStorage.removeItem('token')
   setIsLoggedIn(false)
   setUser(false)
   console.log('Hello')
  }

  

export default SignOut
